import * as yup from "yup";

export const serverUrlSchema = yup.object().shape({
  name: yup.string().required("Required"),
  value: yup.string().required("Required"),
});
